import { escapeMarkdown } from '@crm/contracts';
import type { MeetingDraft } from './drafts.ts';
import type { Meeting } from './meeting.ts';

export const timeOf = (iso: string) =>
  new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
export const dayOf = (iso: string) =>
  new Date(iso).toLocaleDateString([], { weekday: 'short', day: 'numeric', month: 'short' });

/**
 * The note as it lands in the CRM: which meeting and who was in it, then the AM's notes. The
 * tasks are not copied in: each is its own record, so one thing is never saved twice.
 * The title and attendees come from the calendar, so whoever sends the invite controls them: they
 * are escaped (no links, images or HTML). The AM's own notes are not: Markdown there is intended.
 */
export function noteBody(meeting: Meeting, draft: MeetingDraft): string {
  const who = meeting.attendees.map((a) => escapeMarkdown(a.name ?? a.email)).join(', ');
  return [
    `**Meeting:** ${escapeMarkdown(meeting.title)} · ${dayOf(meeting.start)}, ${timeOf(meeting.start)}–${timeOf(meeting.end)}`,
    ...(who ? [`**With:** ${who}`] : []),
    '',
    draft.notes.trim(),
  ]
    .join('\n')
    .trim();
}
